import { render, staticRenderFns } from "./CompanyRelationLink.vue?vue&type=template&id=0b95ae82"
import script from "./CompanyRelationLink.vue?vue&type=script&lang=js"
export * from "./CompanyRelationLink.vue?vue&type=script&lang=js"
import style0 from "./CompanyRelationLink.vue?vue&type=style&index=0&id=0b95ae82&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports